import * as angular from 'angular';
import {IController} from "angular";

export class CancellationReasonRelationsDialogViewCtrl implements IController {
  cancelableServices: any[];
  unCancelableServices: any[];
  cancelRelatedChecked: boolean;
  onCancelableServicesToggled: Function;


}

angular.module('bringoz.admin.action-reasons')
  .component('cancellationReasonRelationsDialogView', {
    bindings: {
      cancelableServices: "<?",
      unCancelableServices: "<?",
      cancelRelatedChecked: "<?",
      onCancelableServicesToggled: "&"
    },
    template: require('./cancellation-reason-relations-dialog-view.html').default,
    controller: CancellationReasonRelationsDialogViewCtrl
  });
